/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef, Suspense } from "react";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import moment from "moment";
import {
  Table,
  Divider,
  Row,
  Input,
  Col,
  Form,
  Upload,
  Menu,
  Select,
  Tabs,
  Spin,
  Space
} from "antd";
import Icon, {
  CaretDownOutlined,
  CaretUpOutlined,
  EditFilled,
  PaperClipOutlined,
  PlusCircleOutlined
} from "@ant-design/icons";
import FileImage from "@assets/images/svg/fileimage.png";
import {
  getTasksLists,
  addTasksActivity,
  getSearchUser,
  deleteTasks as deleteTasksAction,
  updateTasks,
  getAssignedTickets,
  updateNotesData,
  addNotesActivity,
  getNotesLists,
  clearDownloadDocument,
  clearDeleteDocument,
  downloadDocument,
  deleteDocument,
  deleteNotes as deleteNotesAction
} from "@redux/actionCreators";
import { getTasksForm } from "@redux/actionCreators/driver";
import Loader from "@ui/feedback/loader";
import "./tasks.scss";
import { ReactComponent as Delete } from "@assets/images/svg/deleteClose.svg";
import Button from "@ui/form-controls/button";
import DRSDatePicker from "@ui/form-controls/date-picker";
import { useNavigate } from "react-router-dom";
import { safeDecodeURIComponent } from "utils/reusableFunctions";

const detailsMenu = [{ name: "Tasks" }, { name: "Notes" }];
const { Dragger } = Upload;
const { TextArea } = Input;
const { SubMenu } = Menu;
const { TabPane } = Tabs;

const ICON_BUTTON_CLASS =
  "grid h-9 w-9 cursor-pointer place-items-center border-0 bg-transparent p-0 text-lg text-[#888888] hover:text-[#444444]";

const FieldLabel = ({ children }) => (
  <span className="font-open-sans-semibold text-[15px] text-[#222222]">{children}</span>
);

const FIELD_ITEM_CLASS = "!mb-0 [&_.ant-form-item-label]:!pb-1";

const returnParamsData = filesListData => {
  let tempList = [];
  if (filesListData.length !== 0) {
    tempList = filesListData.map(data => {
      return {
        Key: "ATTACHMENT",
        Name: encodeURIComponent(data.name),
        MimeType: "unknown"
      };
    });
  }
  return tempList;
};

// submenu keys of first level
const rootSubmenuKeys = ["sub1"];
const subMenuKeys = ["sub2"];

const Tasks = ({ objectId, loggedUser, isModalVisible, assignTickets, disableDelete }) => {
  const navigate = useNavigate();

  const formRef = useRef();
  const dispatch = useDispatch();

  const [statusData, setStatusData] = useState([]);
  const [typesData, setTypesData] = useState([]);
  const [tasksFileArray, setTasksFileArray] = useState([]);
  const [notesFileArray, setNotesFileArray] = useState([]);
  const [notesData, setNotesData] = useState([]);
  const [editItem, setEditItem] = useState(null);
  const [editNoteItem, setEditNoteItem] = useState(null);
  const [editNoteIndex, setEditNoteIndex] = useState(null);
  const [listingOpen, setListingOpen] = useState(true);
  const [openNotesKeys, setOpenNotesKeys] = useState(["sub2"]);
  const [selectedDoc, setSelectedDoc] = useState(null);

  const driverState = useSelector(state => state.driverReducer || null, shallowEqual);

  const {
    tasksList,
    addTasksActivityInfo,
    searchUserList,
    deleteTasksInfo: deleteTaskInfo,
    updateTasksInfo: updateTaskInfo,
    getAssignedTicketsInfo,
    notesList,
    downloadDocumentInfo,
    deleteNotesInfo
  } = driverState;

  const tasksLists = tasksList.resultData?.TicketList || [];
  const assignedTickets = getAssignedTicketsInfo.resultData?.Data?.Tickets?.ObjectTicketArgs || [];
  const userLists = searchUserList.resultData?.Users;
  const selectedNotes = notesList.resultData?.Notes || [];

  const tasksProps = {
    name: "file",
    multiple: true,
    action: "",
    fileList: tasksFileArray,
    showUploadList: { showDownloadIcon: true },
    customRequest: () => "",
    beforeUpload: file => {
      setFileArrayFn(file, "tasks");
    },
    onRemove: file => {
      removeFileArrayFn(file, "tasks");
    },
    onDownload: file => {
      downloadFileArrayFn(file);
    }
  };

  const notesProps = {
    name: "file",
    multiple: true,
    action: "",
    fileList: notesFileArray,
    showUploadList: { showDownloadIcon: true },
    customRequest: () => "",
    beforeUpload: file => {
      setFileArrayFn(file, "notes");
    },
    onRemove: file => {
      removeFileArrayFn(file, "notes");
    },
    onDownload: file => {
      downloadFileArrayFn(file);
    }
  };

  const {
    addNotesActivityInfo: { resultData: addFlag },
    updateNotesInfo: { resultData: updateNoteFlag }
  } = driverState;

  const downloadFileArrayFn = file => {
    const payload = {
      documentObjectId: file?.objectId,
      documentName: file?.name
    };
    setSelectedDoc(file);
    dispatch(downloadDocument(payload));
  };

  const downloadFile = (file, fileName) => {
    const href = URL.createObjectURL(file);
    const link = document.createElement("a");
    link.href = href;
    link.setAttribute("download", fileName || "attachment.png");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const onOpenChangeNotes = keys => {
    const latestOpenKey = keys.find(key => openNotesKeys.indexOf(key) === -1);
    if (subMenuKeys.indexOf(latestOpenKey) === -1) {
      setOpenNotesKeys(keys);
    } else {
      setOpenNotesKeys(latestOpenKey ? [latestOpenKey] : []);
    }
  };

  const setFileArrayFn = (file, type) => {
    if (type === "tasks") {
      setTasksFileArray(previousFiles => [...previousFiles, file]);
    } else {
      setNotesFileArray(previousFiles => [...previousFiles, file]);
    }
  };

  const removeFileArrayFn = (file, type) => {
    if (file?.objectId) {
      dispatch(deleteDocument([file?.objectId]));
    }
    if (type === "tasks") {
      const filteredFiles = tasksFileArray.filter(item => file.name !== item.name);
      setTasksFileArray([...filteredFiles]);
    } else {
      const filteredFiles = notesFileArray.filter(item => file.name !== item.name);
      setNotesFileArray([...filteredFiles]);
    }
  };

  const saveData = () => {
    if (!isModalVisible && !objectId) {
      return;
    }

    const formValues = JSON.parse(JSON.stringify(formRef.current.getFieldsValue()));
    const tasksFiles = [...tasksFileArray].filter(data => !data.objectId);
    const notesFiles = [...notesFileArray].filter(data => !data.objectId);
    const formData = new FormData();
    dispatch(
      getTasksForm({
        tasksForm: formValues
      })
    );
    if (editItem) {
      const newNotes = notesData.filter(data => data.created === "new");
      const editNotes = notesData.filter(data => data.created === "edit");
      const payload = {
        ObjectId: objectId,
        ticketObjectId: editItem?.ObjectId,
        assignedToUserObjectId: formValues.assignTo,
        ticketTitle: formValues.ticketName,
        description: formValues.description,
        status: formValues.status,
        type: formValues.type,
        notes: newNotes.map(data => {
          if (data.notesFile.length !== 0) {
            data.notesFile.forEach(file => {
              if (!file.objectId) {
                formData.append("filesNotes", file);
              }
            });
          }
          return {
            noteTitle: data.title,
            content: data.content,
            files: returnParamsData(data.notesFile),
            Reminder: data.Reminder.map(rem => {
              return {
                ReminderDate: rem?.ReminderDate // moment(rem?.reminder).format("YYYY-MM-DDTHH:mm:ss")
              };
            })
          };
        }),
        files: returnParamsData(tasksFiles),
        deleteFileList: [],
        updateNotes: editNotes.map(data => {
          if (data.notesFile.length !== 0) {
            data.notesFile.forEach(file => {
              if (!file.objectId) {
                formData.append("filesNotes", file);
              }
            });
          }
          return {
            noteObjectId: data.noteObjectId,
            noteTitle: data.title,
            content: data.content,
            files: returnParamsData(data.notesFile),
            Reminder: data.Reminder.map(rem => {
              return {
                ReminderDate: rem?.ReminderDate // moment(rem?.reminder).format("YYYY-MM-DDTHH:mm:ss")
              };
            }),
            DeleteReminder: data.Reminders.map(item => item?.ObjectId)
          };
        })
      };
      if (tasksFiles.length !== 0) {
        tasksFiles.forEach(file => {
          if (!file.objectId) {
            formData.append("filesTicket", file);
          }
        });
      }
      dispatch(
        updateTasks({
          payload: formData,
          // params: JSON.stringify(payload)
          params: encodeURIComponent(`${JSON.stringify(payload)}`)
        })
      );
      if (loggedUser !== undefined) {
        dispatch(getAssignedTickets(loggedUser?.user?.ObjectId));
      }
    } else {
      const newNotes = notesData.filter(data => data.created === "new");
      const payload = {
        ObjectId: objectId,
        assignedToUserObjectId: formValues.assignTo,
        ticketTitle: formValues.ticketName,
        description: formValues.description || "",
        status: formValues.status,
        type: formValues.type,
        notes: newNotes.map(data => {
          if (data.notesFile.length !== 0) {
            data.notesFile.forEach(file => {
              if (!file.objectId) {
                formData.append("filesNotes", file);
              }
            });
          }
          return {
            noteTitle: data.title,
            content: data.content,
            files: returnParamsData(data.notesFile),
            Reminder: data.Reminder.map(rem => {
              return {
                ReminderDate: rem?.ReminderDate // moment(rem?.reminder).format("YYYY-MM-DDTHH:mm:ss")
              };
            })
          };
        }),
        files: returnParamsData(tasksFiles)
      };
      if (tasksFiles.length !== 0) {
        tasksFiles.forEach(file => {
          if (!file.objectId) {
            formData.append("filesTicket", file);
          }
        });
      }
      // if (notesFiles.length !== 0) {
      //   notesFiles.forEach(file => {
      //     if (!file.objectId) {
      //       formData.append("filesNotes", file);
      //     }
      //   });
      // }
      dispatch(
        addTasksActivity({
          payload: formData,
          // params: JSON.stringify(payload)
          params: encodeURIComponent(`${JSON.stringify(payload)}`)
        })
      );

      if (loggedUser !== undefined) {
        setTimeout(() => {
          dispatch(getAssignedTickets(loggedUser?.user?.ObjectId || loggedUser?.user[0]?.ObjectId));
        }, 1000);
      }
    }
  };

  const saveNotes = () => {
    const newNotes = notesData.filter(data => data.created === "new");
    const editNotes = notesData.filter(data => data.created === "edit");
    const formData = new FormData();
    if (editNotes.length !== 0) {
      const payload = editNotes.map(data => {
        if (data.notesFile.length !== 0) {
          data.notesFile.forEach(file => {
            if (!file.objectId) {
              formData.append("files", file);
            }
          });
        }
        return {
          noteObjectId: data?.noteObjectId,
          ObjectId: editItem?.ObjectId || loggedUser?.user?.ObjectId,
          noteTitle: data.title,
          content: data.content,
          files: returnParamsData(data.notesFile),
          DocumentObjectId: [],
          Reminder: data.Reminder.map(rem => {
            return {
              ReminderDate: moment(rem?.reminder).format("YYYY-MM-DDTHH:mm:ss")
            };
          }),
          DeleteReminder: data.Reminders !== null ? data.Reminders.map(item => item?.ObjectId) : []
        };
      });
      dispatch(
        updateNotesData({
          payload: formData,
          params: encodeURIComponent(`${JSON.stringify(payload)}`)
        })
      );
    }
    if (newNotes.length !== 0) {
      const payload = newNotes.map(data => {
        if (data.notesFile.length !== 0) {
          data.notesFile.forEach(file => {
            if (!file.objectId) {
              formData.append("files", file);
            }
          });
        }
        return {
          ObjectId: editItem?.ObjectId || loggedUser?.user?.ObjectId,
          noteTitle: data.title,
          content: data.content,
          files: returnParamsData(data.notesFile),
          Reminder: data.Reminder.map(rem => {
            return {
              ReminderDate: moment(rem?.reminder).format("YYYY-MM-DDTHH:mm:ss")
            };
          })
        };
      });
      const notesPayload = {
        ObjectId: editItem?.ObjectId || loggedUser?.user?.ObjectId,
        Notes: payload
      };
      dispatch(
        addNotesActivity({
          payload: formData,
          // params: JSON.stringify(notesPayload)
          params: encodeURIComponent(`${JSON.stringify(notesPayload)}`)
        })
      );
    }
  };

  const clearForm = () => {
    navigate(-1);
  };

  const addNotes = () => {
    const formValues = formRef.current.getFieldsValue();
    const note = {
      created: editNoteItem && editNoteItem?.ObjectId ? "edit" : "new",
      title: formValues.title,
      content: formValues.content,
      notesFile: notesFileArray,
      Reminder: formValues.reminders.map(rem => {
        return {
          ReminderDate: moment(rem?.reminder).format("YYYY-MM-DDTHH:mm:ss")
        };
      })
    };
    if (editNoteItem && editNoteItem?.ObjectId) {
      note.noteObjectId = editNoteItem?.ObjectId;
      note.Reminders = editNoteItem?.Reminders;
      const tempArray = notesData.filter(item => item?.ObjectId !== editNoteItem?.ObjectId);
      setNotesData([...tempArray, note]);
    } else {
      const tempArray = notesData.filter(item => item?.title !== editNoteItem?.title);
      setNotesData([...tempArray, note]);
    }
    formRef.current.setFieldsValue({
      title: "",
      content: "",
      notesFile: null,
      reminders: [""]
    });
    setEditNoteItem(null);
    setEditNoteIndex(null);
    setNotesFileArray([]);
  };

  const editNotes = (data, index) => {
    formRef.current.setFieldsValue({
      title: data.title,
      content: data.content,
      notesFile: data.notesFile
    });
    let newValues = [];
    if (data.Reminders !== null && data.Reminders !== undefined) {
      newValues = data.Reminders.map((item, i) => {
        return { reminder: moment(item?.date, "DD-MM-YYYY HH:mm") };
      });
    }

    formRef.current.setFieldsValue({
      reminders: [...newValues]
    });
    const files = (data?.Files || data?.notesFile || []).map(item => {
      return {
        uid: item.ObjectId,
        name: safeDecodeURIComponent(item.Name),
        objectId: item.ObjectId,
        status: "done"
      };
    });
    setNotesFileArray(files);
    setEditNoteItem(data);
    setEditNoteIndex(index);
  };

  const editTasks = data => {
    formRef.current.setFieldsValue({
      title: "",
      content: "",
      notesFile: null,
      reminders: [""]
    });
    setEditNoteItem(null);
    setEditNoteIndex(null);
    setNotesFileArray([]);
    formRef.current.setFieldsValue({
      ticketName: data?.Title,
      assignTo: data?.AssignedToUserObjectId,
      status: data?.Status,
      type: data?.TicketType,
      description: data?.Description,
      tasksFile: data?.Files,
      objectId: data?.ObjectId
    });
    setEditItem(data);
    const files = (data?.Files || data?.tasksFile || []).map(item => {
      return {
        uid: item.ObjectId,
        name: safeDecodeURIComponent(item.Name),
        objectId: item.ObjectId,
        status: "done"
      };
    });
    setTasksFileArray(files);
    const tempData = data.Notes || [];
    const notes = tempData.map(data => {
      return {
        title: data?.Title,
        content: data?.Body,
        notesFile: data?.Files,
        reminders: data?.Reminders.map(item => moment(item?.date, "DD-MM-YYYY HH:mm")),
        ...data
      };
    });
    setNotesData(notes);
  };

  const editTickets = data => {
    formRef.current.setFieldsValue({
      title: "",
      content: "",
      notesFile: null,
      reminders: [""]
    });
    setEditNoteItem(null);
    setEditNoteIndex(null);
    setNotesFileArray([]);
    formRef.current.setFieldsValue({
      description: data?.Description,
      objectId: data?.ObjectId
    });
    setEditItem(data);
    dispatch(getNotesLists(data?.ObjectId));
  };

  const deleteTasks = data => {
    dispatch(deleteTasksAction(data.ObjectId));
  };

  const deleteNotes = data => {
    if (data?.created === "new") {
      const tempArray = notesData.filter(item => item?.title !== data?.title);
      setNotesData(tempArray);
    } else {
      dispatch(deleteNotesAction(data?.ObjectId || data?.noteObjectId));
      const tempArray = notesData.filter(item => item?.title !== data?.title);
      setNotesData(tempArray);
    }
  };

  const clearFields = () => {
    dispatch(clearDownloadDocument());
    dispatch(clearDeleteDocument());
    formRef.current.resetFields();
    setNotesFileArray([]);
    setTasksFileArray([]);
    setNotesData([]);
    setEditItem(null);
    setSelectedDoc(null);
    setEditNoteItem(null);
    setEditNoteIndex(null);
  };

  useEffect(() => {
    if (loggedUser !== undefined) {
      if (isModalVisible) {
        dispatch(getAssignedTickets(loggedUser?.user?.ObjectId));
      }
    }
  }, [dispatch, isModalVisible, loggedUser]);

  useEffect(() => {
    const tempData = selectedNotes || [];
    const notes = tempData.map(data => {
      let payload = {};
      if (data !== undefined || data !== null) {
        payload = {
          title: data?.Title,
          content: data?.Body,
          notesFile: data?.Files,
          reminders:
            data.Reminders !== null
              ? data?.Reminders.map(item => moment(item?.date, "DD-MM-YYYY HH:mm"))
              : [],
          ...data
        };
      } else {
        payload = {
          title: data?.Title,
          content: data?.Body,
          notesFile: data?.Files,
          reminders: data?.Reminders.map(item => moment(item?.date, "DD-MM-YYYY HH:mm")),
          ...data
        };
      }
      return payload;
    });
    setNotesData(notes);
  }, [notesList.resultData]);

  useEffect(() => {
    if (!isModalVisible) {
      dispatch(getSearchUser(""));
      if (objectId) {
        dispatch(getTasksLists(objectId));
      }
    }
    setStatusData(["Open", "Resolved"]);
    setTypesData([
      "CriticalRequest",
      "CriticalQuery",
      "UrgentRequest",
      "UrgentQuery",
      "Request",
      "Query",
      "Complaint",
      "Infringement"
    ]);
    dispatch(clearDownloadDocument());
    dispatch(clearDeleteDocument());
    setNotesFileArray([]);
    setTasksFileArray([]);
    setNotesData([]);
    setSelectedDoc(null);
    return () => {
      dispatch(clearDownloadDocument());
      dispatch(clearDeleteDocument());
      setNotesFileArray([]);
      setTasksFileArray([]);
      setSelectedDoc(null);
    };
  }, [dispatch, isModalVisible, objectId]);

  useEffect(() => {
    if (
      addTasksActivityInfo.resultData ||
      deleteTaskInfo.resultData ||
      updateTaskInfo.resultData
    ) {
      if (isModalVisible) {
        if (isModalVisible) {
          dispatch(getAssignedTickets(loggedUser?.user?.ObjectId));
        }
        dispatch(clearDownloadDocument());
        dispatch(clearDeleteDocument());
        formRef.current.resetFields();
        setNotesData([]);
        setNotesFileArray([]);
        setTasksFileArray([]);
      } else {
        if (objectId) {
          dispatch(getTasksLists(objectId));
        }
        dispatch(clearDownloadDocument());
        dispatch(clearDeleteDocument());
        formRef.current.resetFields();
        setNotesFileArray([]);
        setTasksFileArray([]);
        setNotesData([]);
      }
    }
  }, [
    addTasksActivityInfo.resultData,
    deleteTaskInfo.resultData,
    deleteNotesInfo,
    dispatch,
    isModalVisible,
    loggedUser,
    objectId,
    updateTaskInfo.resultData
  ]);

  useEffect(() => {
    if (downloadDocumentInfo.resultData) {
      downloadFile(downloadDocumentInfo.resultData, selectedDoc?.name);
      setSelectedDoc(null);
    }
  }, [downloadDocumentInfo.resultData]);

  useEffect(() => {
    if (editItem && (addFlag || updateNoteFlag)) {
      dispatch(getNotesLists(editItem.ObjectId));
    }
  }, [addFlag, updateNoteFlag]);

  const menuListData = isModalVisible ? assignedTickets : tasksLists;

  return (
    <div className="tasks-form">
      <Spin
        indicator={<Loader />}
        spinning={
          tasksList.isLoading ||
          addTasksActivityInfo.isLoading ||
          deleteTaskInfo.isLoading ||
          updateTaskInfo.isLoading ||
          getAssignedTicketsInfo.isLoading
        }
        className="loaderGifPosition"
      >
        <div className="mr-auto flex max-w-[1280px] flex-wrap items-start gap-3 text-left">
          <aside className="w-full min-w-0 max-w-[360px] basis-[300px] grow shrink bg-[#efefef]">
            <div className="flex h-10 items-center justify-between gap-3 border-0 border-b border-solid border-[#e2e2e2] py-0 pl-4 pr-1">
              <div className="flex min-w-0 items-baseline gap-2">
                <h2 className="m-0 text-[15px] font-normal text-[#8a8a8a]">Ticket Listing</h2>
                <span className="text-[13px] text-[#8a8a8a]">{menuListData.length}</span>
              </div>
              <div className="flex items-center gap-1">
                {editItem && assignTickets === undefined ? (
                  <Button variant="outline" size="sm" onClick={() => clearFields()}>
                    Add New
                  </Button>
                ) : null}
                <button
                  type="button"
                  aria-label={listingOpen ? "Collapse ticket listing" : "Expand ticket listing"}
                  aria-expanded={listingOpen}
                  className={ICON_BUTTON_CLASS}
                  onClick={() => setListingOpen(open => !open)}
                >
                  {listingOpen ? <CaretUpOutlined /> : <CaretDownOutlined />}
                </button>
              </div>
            </div>
            {listingOpen ? (
              <ul className="m-0 list-none p-0">
                {menuListData.map(data => (
                  <li
                    key={data.ObjectId}
                    className="flex min-h-10 cursor-pointer items-center gap-2 border-0 border-b border-solid border-[#e2e2e2] bg-[#ebebeb] py-0 pl-4 pr-1 last:border-b-0 hover:bg-[#e4e4e4]"
                    onClick={() => (isModalVisible ? editTickets(data) : editTasks(data))}
                  >
                    <span className="min-w-0 flex-1 overflow-hidden text-ellipsis whitespace-nowrap text-[15px] text-[#222222]">
                      {data?.Title}
                    </span>
                    <button
                      type="button"
                      aria-label={`Edit ticket: ${data?.Title || ""}`}
                      className={ICON_BUTTON_CLASS}
                      onClick={event => {
                        event.stopPropagation();
                        if (isModalVisible) {
                          editTickets(data);
                        } else {
                          editTasks(data);
                        }
                      }}
                    >
                      <EditFilled />
                    </button>
                    {disableDelete === undefined ? (
                      <button
                        type="button"
                        aria-label={`Delete ticket: ${data?.Title || ""}`}
                        className={ICON_BUTTON_CLASS}
                        onClick={event => {
                          event.stopPropagation();
                          deleteTasks(data);
                        }}
                      >
                        <Icon component={Delete} />
                      </button>
                    ) : null}
                  </li>
                ))}
                {menuListData.length === 0 ? (
                  <li className="px-4 py-2.5 text-[15px] text-[#6b6b6b]">No Ticket added yet</li>
                ) : null}
              </ul>
            ) : null}
          </aside>

          <section className="min-w-0 flex-[999_1_560px] border border-solid border-[#dddddd] bg-white shadow-[0_1px_3px_rgba(0,0,0,0.06)]">
            <Form
              name="dynamic_form_nest_holidays_details"
              autoComplete="off"
              colon={false}
              className="additional-detail-form additional-detail-form-license tasks-tab-form !border-0 !px-0 !shadow-none"
              ref={formRef}
              initialValues={{ reminders: [] }}
            >
              <div className="px-4 pt-2.5">
                <h2 className="m-0 font-open-sans-semibold text-[15px] text-[#222222]">
                  {editItem ? "Edit ticket" : "Create ticket"}
                </h2>
              </div>
              <div className="px-4 pb-3 pt-2">
              <Tabs defaultActiveKey="Tasks" className="details-all-tabs !w-full !p-0">
                {[...detailsMenu].map(({ name }) => (
                  <TabPane tab={`${name}`} key={name}>
                    <Suspense fallback={<Loader />}>
                      {name === "Tasks" && !isModalVisible && (
                        <div className="flex flex-col gap-3">
                          <Form.Item
                            className={FIELD_ITEM_CLASS}
                            labelCol={{ span: 24 }}
                            label={<FieldLabel>Name</FieldLabel>}
                            name="ticketName"
                            fieldKey="ticketName"
                            rules={[{ required: true, message: "Missing Name" }]}
                          >
                            <Input placeholder="Enter Name" />
                          </Form.Item>

                          <div className="grid grid-cols-1 gap-x-4 gap-y-3 md:grid-cols-3">
                            <Form.Item
                              className={FIELD_ITEM_CLASS}
                              labelCol={{ span: 24 }}
                              label={<FieldLabel>Assign To</FieldLabel>}
                              name="assignTo"
                              fieldKey="assignTo"
                              rules={[{ required: true, message: "Missing Assign To" }]}
                            >
                              <Select
                                dropdownStyle={{ zIndex: 2000 }}
                                showSearch
                                allowClear
                                placeholder="Search to Select"
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                                filterSort={(optionA, optionB) =>
                                  optionA.children
                                    .toLowerCase()
                                    .localeCompare(optionB.children.toLowerCase())
                                }
                              >
                                {userLists &&
                                  userLists.map(data => (
                                    <Select.Option
                                      value={data.ObjectId}
                                      key={data.ObjectId}
                                      className="ant-select-options"
                                    >
                                      {data.Username}
                                    </Select.Option>
                                  ))}
                              </Select>
                            </Form.Item>
                            <Form.Item
                              className={FIELD_ITEM_CLASS}
                              labelCol={{ span: 24 }}
                              label={<FieldLabel>Status</FieldLabel>}
                              name="status"
                              fieldKey="status"
                              rules={[{ required: true, message: "Missing Status" }]}
                            >
                              <Select
                                dropdownStyle={{ zIndex: 2000 }}
                                showSearch
                                allowClear
                                placeholder="Search to Select"
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                                filterSort={(optionA, optionB) =>
                                  optionA.children
                                    .toLowerCase()
                                    .localeCompare(optionB.children.toLowerCase())
                                }
                              >
                                {statusData &&
                                  statusData.map(data => (
                                    <Select.Option
                                      value={data}
                                      key={data}
                                      className="ant-select-options"
                                    >
                                      {data}
                                    </Select.Option>
                                  ))}
                              </Select>
                            </Form.Item>
                            <Form.Item
                              className={FIELD_ITEM_CLASS}
                              labelCol={{ span: 24 }}
                              label={<FieldLabel>Type</FieldLabel>}
                              name="type"
                              fieldKey="type"
                              rules={[{ required: true, message: "Missing Type" }]}
                            >
                              <Select
                                dropdownStyle={{ zIndex: 2000 }}
                                showSearch
                                allowClear
                                placeholder="Search to Select"
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                                filterSort={(optionA, optionB) =>
                                  optionA.children
                                    .toLowerCase()
                                    .localeCompare(optionB.children.toLowerCase())
                                }
                              >
                                {typesData &&
                                  typesData.map(data => (
                                    <Select.Option
                                      value={data}
                                      key={data}
                                      className="ant-select-options"
                                    >
                                      {data}
                                    </Select.Option>
                                  ))}
                              </Select>
                            </Form.Item>
                          </div>

                          <Form.Item
                            className={FIELD_ITEM_CLASS}
                            labelCol={{ span: 24 }}
                            label={<FieldLabel>Description</FieldLabel>}
                            name="description"
                            fieldKey="description"
                            rules={[{ required: true, message: "Missing Description" }]}
                          >
                            <TextArea rows={3} className="!min-h-[72px]" />
                          </Form.Item>

                          <div className="flex flex-col gap-2 border-0 border-t border-solid border-[#ececec] pt-3">
                            <h3 className="m-0 font-open-sans-semibold text-[15px] text-[#222222]">
                              Attach Document
                            </h3>
                            <div className="attach-file-div">
                              <div className="draggerbox m-0 flex flex-wrap items-center gap-x-4 gap-y-2 border border-dashed border-[#bdbdbd] bg-[#eeeeee] px-4 py-2">
                                <div className="file-details !p-0">
                                  <img src={FileImage} alt="" className="!h-12 !w-12 rounded-full" />
                                </div>
                                <Form.Item
                                  className="!mb-0 min-w-0 flex-1"
                                  labelCol={{ span: 24 }}
                                  name="tasksFile"
                                  fieldKey="tasksFile"
                                  rules={[{ required: false, message: "Missing Document" }]}
                                >
                                  <Dragger {...tasksProps}>
                                    <PaperClipOutlined className="clip-icon" />
                                    <a className="addFile">Add File </a>
                                    <p className="draggertitle">or Drop files here</p>
                                    <p className="fileType">
                                      Only .PDF, .JPEG, .JPG and .PNG files allowed to upload
                                    </p>
                                  </Dragger>
                                </Form.Item>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                      {name === "Tasks" && isModalVisible && (
                        <Row gutter={[16, { xs: 8, sm: 16, md: 24, lg: 32 }]}>
                          <Col span={22}>
                            <Form.Item
                              labelCol={{ span: 24 }}
                              label="Description"
                              name="description"
                              fieldKey="description"
                              rules={[{ required: false, message: "Missing Description" }]}
                            >
                              <TextArea rows={4} disabled />
                            </Form.Item>
                          </Col>
                        </Row>
                      )}

                      {name === "Notes" && (
                        <div className="">
                          <Row gutter={[16, { xs: 8, sm: 16, md: 24, lg: 32 }]}>
                            <Col span={10}>
                              <Spin
                                indicator={<Loader />}
                                spinning={notesList.isLoading}
                                className="loaderGifPosition"
                              >
                                <Menu
                                  mode="inline"
                                  openKeys={openNotesKeys}
                                  onOpenChange={onOpenChangeNotes}
                                  style={{ background: "#F1F1F1" }}
                                >
                                  <SubMenu key="sub2" title="Notes Listing">
                                    {notesData &&
                                      notesData.map((data, i) => (
                                        <Menu.Item
                                          value={i}
                                          // eslint-disable-next-line react/no-array-index-key
                                          key={i}
                                          icon={
                                            <div className="edit-icon">
                                              <EditFilled
                                                className="icon-behaviour"
                                                onClick={() => editNotes(data, i)}
                                              />
                                              <Icon
                                                component={Delete}
                                                className="icon-behaviour delete-icon"
                                                onClick={() => deleteNotes(data)}
                                              />
                                            </div>
                                          }
                                        >
                                          {data.title}
                                        </Menu.Item>
                                      ))}
                                    {notesData.length === 0 && (
                                      <Menu.Item value={null} key="noData">
                                        No Notes added yet
                                      </Menu.Item>
                                    )}
                                  </SubMenu>
                                </Menu>
                              </Spin>
                            </Col>
                            <Col span={14}>
                              <Row gutter={[16, { xs: 8, sm: 16, md: 24, lg: 32 }]}>
                                <Col span={16}>
                                  <Form.Item
                                    labelCol={{ span: 24 }}
                                    label="Note Title"
                                    name="title"
                                    fieldKey="title"
                                    rules={[{ required: true, message: "Missing Note Title" }]}
                                  >
                                    <Input placeholder="Enter Note Title" />
                                  </Form.Item>
                                </Col>
                              </Row>
                              <Row gutter={[16, { xs: 8, sm: 16, md: 24, lg: 32 }]}>
                                <Col span={24}>
                                  <Form.Item
                                    labelCol={{ span: 24 }}
                                    label="Content"
                                    name="content"
                                    fieldKey="content"
                                    rules={[{ required: true, message: "Missing Content" }]}
                                  >
                                    <TextArea rows={4} />
                                  </Form.Item>
                                </Col>
                              </Row>
                              <Row justify="start" align="middle">
                                <span className="sections">Reminders</span>
                              </Row>
                              <Row gutter={[16, { xs: 8, sm: 16, md: 24, lg: 32 }]}>
                                <Form.List name="reminders">
                                  {(fields, { add, remove }) => (
                                    <>
                                      {fields.map(({ key, name, fieldKey, ...restField }) => (
                                        <Space
                                          key={key}
                                          style={{
                                            display: "flex",
                                            margin: 8
                                          }}
                                        >
                                          <Form.Item
                                            {...restField}
                                            label=""
                                            name={[name, "reminder"]}
                                            fieldKey={[fieldKey, "reminder"]}
                                            rules={[
                                              { required: true, message: "Missing reminder" }
                                            ]}
                                          >
                                            <DRSDatePicker format="DD-MM-YYYY HH:mm" showTime />
                                          </Form.Item>
                                          <Form.Item labelCol={{ span: 24 }} label="">
                                            <Icon
                                              component={Delete}
                                              className="icon-behaviour"
                                              onClick={() => remove(name)}
                                            />
                                          </Form.Item>
                                        </Space>
                                      ))}
                                      <Form.Item>
                                        <Row justify="space-between" align="middle">
                                          <Button
                                            className="add-button"
                                            variant="ghost"
                                            onClick={() => add()}
                                            icon={<PlusCircleOutlined />}
                                          >
                                            Add
                                          </Button>
                                        </Row>
                                      </Form.Item>
                                    </>
                                  )}
                                </Form.List>
                              </Row>
                              <Row gutter={[16, { xs: 8, sm: 16, md: 24, lg: 32 }]}>
                                <Col span={16}>
                                  <div className="attach-file-div">
                                    <Row justify="start" align="middle">
                                      <span className="f-title">Attach Notes Document</span>
                                    </Row>
                                    <Row className="draggerbox">
                                      <div className="file-details">
                                        <img src={FileImage} alt="FileImage" />
                                      </div>
                                      <Divider type="vertical" className="divider" />
                                      <Form.Item
                                        labelCol={{ span: 24 }}
                                        name="notesFile"
                                        fieldKey="notesFile"
                                        rules={[{ required: false, message: "Missing Document" }]}
                                      >
                                        <Dragger {...notesProps}>
                                          <PaperClipOutlined className="clip-icon" />
                                          <a className="addFile">Add File </a>
                                          <p className="draggertitle">or Drop files here</p>
                                          <p className="fileType">
                                            Only .PDF, .JPEG, .JPG and .PNG files allowed to upload
                                          </p>
                                        </Dragger>
                                      </Form.Item>
                                      <Divider />
                                    </Row>
                                  </div>
                                </Col>
                              </Row>
                              <Form.Item>
                                <Row justify="space-between" align="middle">
                                  <Button
                                    className="add-button"
                                    variant="ghost"
                                    icon={<PlusCircleOutlined />}
                                    onClick={() => addNotes()}
                                  >
                                    Add
                                  </Button>
                                </Row>
                              </Form.Item>
                            </Col>
                          </Row>
                          {editNoteItem && (
                            <Row gutter={[16, { xs: 8, sm: 24, md: 24, lg: 32 }]}>
                              <p>
                                <span style={{ fontWeight: "bold", padding: "0px 5px" }}>
                                  Created
                                </span>
                                {moment(editNoteItem?.CreateDate).format("DD/MM/YYYY hh:mm:ss")}
                                <span style={{ fontWeight: "bold", padding: "0px 5px" }}>by</span>
                                {editNoteItem?.AuthorName}
                                <span style={{ fontWeight: "bold", padding: "0px 5px" }}>
                                  Last edited
                                </span>
                                {moment(editNoteItem?.LastEditDate).format("DD/MM/YYYY hh:mm:ss")}
                                <span style={{ fontWeight: "bold", padding: "0px 5px" }}>by</span>
                                {editNoteItem?.LastEditName}
                              </p>
                            </Row>
                          )}
                        </div>
                      )}
                    </Suspense>
                  </TabPane>
                ))}
              </Tabs>
              </div>
              <div className="flex flex-wrap justify-end gap-2 border-0 border-t border-solid border-[#ececec] px-4 py-2">
                <Button variant="outline" onClick={() => clearForm()}>
                  Cancel
                </Button>
                <Button
                  variant="primary"
                  htmlType="submit"
                  onClick={() => (isModalVisible ? saveNotes() : saveData())}
                  disabled={!isModalVisible && !objectId}
                >
                  Save
                </Button>
              </div>
            </Form>
          </section>
        </div>
      </Spin>
    </div>
  );
};

export default Tasks;
